//export default class Facts {
//   constructor() {
//     this.$sections = document.querySelectorAll('section.facts');
//   }
//}
//
//new Facts();

import AOS from "aos";
import "aos/dist/aos.css";
import Rellax from "rellax";

document.addEventListener("DOMContentLoaded", () => {
  AOS.init();
  if (document.querySelector(".rellax")) {
    new Rellax(".rellax");
  }
});
